import { Fragment, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router'
import {
  Toolbar,
  SaveButton,
  List,
  SimpleForm,
  DateInput,
  DateField,
  TextInput,
  Datagrid,
  Edit,
  Create,
  TextField,
  ReferenceField,
  ReferenceInput,
  NumberField,
  SelectInput,
  required,
  choices,
  FormDataConsumer,
  useUpdate,
  ReferenceManyField,
  AutocompleteInput,
  Show,
  SimpleShowLayout,
  useDataProvider,
  useRefresh,
  useGetOne,
  useNotify,
  BooleanInput,
  RichTextField,
  Loading,
  useGetList,
  useTranslate,
  useRedirect,
  useRecordContext,
  FilterButton,
  FilterForm,
  useGetManyReference,
  DateTimeInput,
  TopToolbar,
  useGetIdentity,
} from 'react-admin'
import { keyframes } from '@mui/system'

import { useFormContext } from 'react-hook-form'
import { useChoicesContext, useListContext } from 'ra-core'
import {
  Button,
  IconButton,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Badge,
  List as ListM,
  ListItem,
  ListItemIcon,
  ListItemText,
  Link,
  Typography,
  Grid,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  Box,
  FormControlLabel,
  Checkbox,
  Modal,
  Slide,
  TextField as TextFieldUI,
  DialogContentText,
  Drawer,
  useMediaQuery,
} from '@material-ui/core'
import Chip from '@mui/material/Chip'
import { makeStyles, styled } from '@material-ui/core/styles'
import {
  CustomToolbar,
  validatePhone,
  formatPhone,
  ExtraPagination,
  draft_color,
} from './utils'

import moment from 'moment'
import TextFieldWithTooltip from './components/text_field_with_tooltip'
import DateRangePicker from './components/common/DateRangePicker/DateRangePicker'

import {
  CreateButtonWithState,
  TicketCol,
  DraftActionsCol,
  CoproManager,
} from './tickets_generic'
import { ToggleButton } from '@mui/material'

const DraftTicketFilter = (props) => {
  const dataProvider = useDataProvider()
  const [squadChoices, setSquadChoices] = useState([])
  const [coproManagerChoices, setCoproManagerChoices] = useState([])

  useEffect(() => {
    dataProvider
      .getList('copros_monday/squads', {
        pagination: { page: 1, perPage: 100 },
        sort: { field: 'squad_number', order: 'ASC' },
        filter: {},
      })
      .then(({ data }) => {
        setSquadChoices(data)
      })
      .catch(() => {
        setSquadChoices([])
      })

    dataProvider
      .getList('copros_monday/copro_managers', {
        pagination: { page: 1, perPage: 100 },
        sort: { field: 'copro_manager', order: 'ASC' },
        filter: {},
      })
      .then(({ data }) => {
        setCoproManagerChoices(data)
      })
      .catch(() => {
        setCoproManagerChoices([])
      })
  }, [dataProvider])

  return [
    <TextInput sx={{ width: 250 }} source="q" label="Rechercher" alwaysOn />,
    <ReferenceInput source="process_id" reference="tickets/processes" alwaysOn>
      <AutocompleteInput
        sx={{ width: 250, ' button': { padding: '4px;' } }}
        optionValue="id"
        optionText="name"
        size="small"
        resettable={false}
        clearAlwaysVisible={false}
      />
    </ReferenceInput>,
    <ReferenceInput
      source="copro_id"
      label="Code Copro"
      reference="copros_monday"
      alwaysOn
    >
      <AutocompleteInput
        sx={{ width: 250, ' button': { padding: '4px;' } }}
        optionValue="id"
        optionText="code"
        size="small"
        resettable={false}
        clearAlwaysVisible={false}
        label="Copropriété"
        matchSuggestion={() => true}
      />
    </ReferenceInput>,
    <TextInput fullWidth={true} source="id" label="Ticket id" />,
    <ReferenceInput
      source="creator_id"
      label="Créateur"
      reference="users"
      sort={{ field: 'lastname', order: 'ASC' }}
      filter={{ excludeEmptyNames: true }}
      alwaysOn
    >
      <AutocompleteInput
        optionValue="id"
        optionText={(choice) =>
          choice && choice.firstname && choice.lastname
            ? `${choice.firstname} ${choice.lastname}`
            : ''
        }
        filterToQuery={(searchText) => ({ q: searchText })}
        size="small"
        label="Créateur"
        resettable={false}
        clearAlwaysVisible={false}
        matchSuggestion={() => true}
        sx={{ width: 250 }}
      />
    </ReferenceInput>,
    <ReferenceInput
      source="ext_creator_id"
      label="Créateur Externe"
      reference="coproprietaires"
      sort={{ field: 'name', order: 'ASC' }}
      alwaysOn
    >
      <AutocompleteInput
        optionValue="id"
        optionText={(choice) => (choice && choice.name ? `${choice.name}` : '')}
        filterToQuery={(searchText) => ({ q: searchText })}
        size="small"
        label="Créateur Externe"
        resettable={false}
        clearAlwaysVisible={false}
        matchSuggestion={() => true}
        sx={{ width: 250 }}
      />
    </ReferenceInput>,
    <SelectInput
      source="squad_number"
      label="Squad"
      choices={squadChoices}
      alwaysOn
      sx={{
        marginBottom: 0,
        minWidth: 115,
        '& .MuiInputBase-root': {
          minWidth: '115px',
        },
      }}
    />,
    <SelectInput
      source="resp"
      label="Copro Manager"
      choices={coproManagerChoices}
      alwaysOn
      sx={{
        marginBottom: 0,
      }}
    />,
  ]
}

const ListActions = (props) => {
  const { handleSelect, dateRange } = props

  const { setFilters, filterValues } = useListContext()
  const { identity } = useGetIdentity()
  const currentUserId = identity?.id

  const handleSetCreator = (newCreatorId) => {
    setFilters({
      ...filterValues,
      creator_id:
        filterValues.creator_id === newCreatorId ? undefined : newCreatorId,
    })
  }

  return (
    <TopToolbar sx={{ width: '100%', mt: 1 }}>
      <Grid container spacing={2} alignItems="center">
        <Grid
          item
          xs={12}
          container
          spacing={2}
          alignItems="center"
          justifyContent="flex-start"
        >
          <Grid item>
            <style>
              {`
                .rdrDateDisplay {
                  margin-left: 0 !important;
                }
              `}
            </style>
            <DateRangePicker
              handleSelect={handleSelect}
              ranges={dateRange}
              collapsed={true}
              maxDate={new Date()}
              source={'tickets'}
              style={{
                padding: 0,
                margin: 0,
              }}
            />
          </Grid>
          <Grid item>
            <ToggleButton
              value="creator"
              selected={filterValues.creator_id === currentUserId}
              onChange={() => handleSetCreator(currentUserId)}
              size="small"
              sx={{
                backgroundColor:
                  filterValues.creator_id === currentUserId
                    ? 'transparent'
                    : 'primary.main',
                color:
                  filterValues.creator_id === currentUserId
                    ? 'primary.main'
                    : 'white',
                boxShadow:
                  filterValues.creator_id === currentUserId
                    ? 'inset 0px 4px 6px rgba(0,0,0,0.2)'
                    : '0px 4px 6px rgba(0,0,0,0.1)',
                transition: 'all 0.2s ease-in-out',
                '&:hover': {
                  backgroundColor:
                    filterValues.creator_id === currentUserId
                      ? 'primary.dark'
                      : 'primary.light',
                },
              }}
            >
              Mes tickets créés
            </ToggleButton>
          </Grid>
        </Grid>

        <Grid item xs={12} container spacing={2} alignItems="center">
          <Grid item>
            <FilterForm
              filters={DraftTicketFilter({ ...props })}
              style={{ rowGap: 15, width: 'auto' }}
              className="filter_form_ticket"
            />
          </Grid>
        </Grid>
      </Grid>
    </TopToolbar>
  )
}

const TicketDescription = () => {
  const record = useRecordContext()
  return (
    <TextFieldWithTooltip
      record={record.content}
      maxLength={300}
      source="description"
      maxLines={2}
    />
  )
}
export const TicketListDraft = (props) => {
  let [dateRange, setDateRange] = useState({
    startDate: moment().subtract(5, 'month').toDate(),
    endDate: moment().toDate(),
    key: 'selection',
  })
  let handleSelect = (ranges) => {
    setDateRange({
      startDate: ranges.selection.startDate,
      endDate: ranges.selection.endDate,
      key: 'selection',
    })
  }
  let tickets_filter = {
    date_start: moment(dateRange.startDate).format('YYYY-MM-DD 00:00:00'),
    date_end: moment(dateRange.endDate).format('YYYY-MM-DD 23:59:59'),
    ...props.filter,
  }

  const { state } = useLocation()
  let styles = props.styles
  if (!styles) {
    styles = {}
  }

  // @todo:
  return (
    <div>
      <List
        resource="tickets_drafts"
        basePath="/"
        title=" "
        sort={{ field: 'created', order: 'DESC' }}
        exporter={false}
        filterDefaultValues={{
          id: state?.id,
        }}
        actions={
          <ListActions
            {...props}
            handleSelect={handleSelect}
            dateRange={dateRange}
            state={state}
          />
        }
        filter={{ ...tickets_filter }}
        perPage={10}
      >
        <Datagrid
          isRowSelectable={false}
          bulkActionButtons={false}
          sx={{
            '& .MuiTableHead-root': {
              textTransform: 'uppercase',
            },
            '& .MuiTableCell-head': {
              fontWeight: 'bold',
            },
          }}
        >
          <TicketCol
            isDraftTicket={true}
            label="resources.tickets.fields.ticket_col"
          />
          <TextField source="process_name" label="Process" />
          <TicketDescription label="Description" />
          <TextFieldWithTooltip
            source="creator"
            label="Créateur"
            maxLength={10}
          />
          <TextField source="ext_creator" label="Créateur ext" />
          <TextField
            source="squad_number"
            label="Squad"
            sx={{
              display: 'block',
              textAlign: 'center',
            }}
          />
          <CoproManager label="CM" />
          <DateField source="created" label="Création" />
          <CreateButtonWithState asLink={true} />
          <DraftActionsCol />
        </Datagrid>
      </List>
    </div>
  )
}
